import ListingUrlBuilder from '../models/ListingUrlBuilder';

export default class ListingUrlFormatter {
    format(listingRequest) {
        const {
            baseUrl,
            arrival,
            departure,
            adultsCount,
            childrenCount,
            petIncluded,
            ...rest
        } = listingRequest;

        return ListingUrlBuilder.builder()
            .addBaseUrl(baseUrl) // this needs to be called first, order is important
            .addDateParameters(arrival, departure)
            .addGuestParameters(adultsCount, childrenCount, petIncluded)
            .addQueryParameters(rest)
            .build();
    }
}
